module.exports = __webpack_public_path__ + "static/media/promo.a4490120.png";